module.exports = __webpack_public_path__ + "img/1.5fee3fd9.png";